/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCargoMovement = /* GraphQL */ `
  query GetCargoMovement($id: ID!) {
    getCargoMovement(id: $id) {
      id
      secuencia
      bl_guia
      origin
      puerto_carga
      destino
      puerto_descarga
      agente_transporte
      tipo_transporte
      commotity
      measures
      weigth
      vweigth
      etd
      eta
      tipo_despacho
      almacen_fiscal
      recibo
      semaforo
      dua
      fecha_dua
      transporte_interno
      tramitador
      status
      createdAt
      type
      boxes {
        items {
          id
          secuencia
          warehouseNumber
          client
          provedor
          origin
          puerto_carga
          destino
          puerto_descarga
          manifiest_number
          measures
          weigth
          vweigth
          warehouse_prealert_id
          tipo_transporte
          delivery_type
          commotity
          createdAt
          isDelivered
          onRoute
          tracking_num
          tax_calculated
          received
          exempt_process_request
          courier
          cost
          type
          cargoMovement {
            id
            secuencia
            bl_guia
            origin
            puerto_carga
            destino
            puerto_descarga
            agente_transporte
            tipo_transporte
            commotity
            measures
            weigth
            vweigth
            etd
            eta
            tipo_despacho
            almacen_fiscal
            recibo
            semaforo
            dua
            fecha_dua
            transporte_interno
            tramitador
            status
            createdAt
            type
            boxes {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          deliveryRoute {
            id
            secuencia
            delivery_man
            date
            status
            comments
            createdAt
            updatedAt
            type
            boxes {
              nextToken
              __typename
            }
            __typename
          }
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          poBoxBoxesId
          boxAssets {
            items {
              id
              name
              path
              type
              size
              createdAt
              updatedAt
              boxBoxAssetsId
              __typename
            }
            nextToken
            __typename
          }
          boxCost {
            id
            invoiceId
            settlementId
            subtotal
            iva
            discount
            comision
            total
            priceType
            exchangeRate
            createdAt
            type
            box {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            data
            easyposLog
            updatedAt
            boxCostBoxId
            __typename
          }
          data
          updatedAt
          cargoMovementBoxesId
          deliveryRouteBoxesId
          boxBoxCostId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listCargoMovements = /* GraphQL */ `
  query ListCargoMovements(
    $filter: ModelCargoMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCargoMovements(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        secuencia
        bl_guia
        origin
        puerto_carga
        destino
        puerto_descarga
        agente_transporte
        tipo_transporte
        commotity
        measures
        weigth
        vweigth
        etd
        eta
        tipo_despacho
        almacen_fiscal
        recibo
        semaforo
        dua
        fecha_dua
        transporte_interno
        tramitador
        status
        createdAt
        type
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cargoMovementsByDate = /* GraphQL */ `
  query CargoMovementsByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCargoMovementFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cargoMovementsByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        secuencia
        bl_guia
        origin
        puerto_carga
        destino
        puerto_descarga
        agente_transporte
        tipo_transporte
        commotity
        measures
        weigth
        vweigth
        etd
        eta
        tipo_despacho
        almacen_fiscal
        recibo
        semaforo
        dua
        fecha_dua
        transporte_interno
        tramitador
        status
        createdAt
        type
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeliveryRoute = /* GraphQL */ `
  query GetDeliveryRoute($id: ID!) {
    getDeliveryRoute(id: $id) {
      id
      secuencia
      delivery_man
      date
      status
      comments
      createdAt
      updatedAt
      type
      boxes {
        items {
          id
          secuencia
          warehouseNumber
          client
          provedor
          origin
          puerto_carga
          destino
          puerto_descarga
          manifiest_number
          measures
          weigth
          vweigth
          warehouse_prealert_id
          tipo_transporte
          delivery_type
          commotity
          createdAt
          isDelivered
          onRoute
          tracking_num
          tax_calculated
          received
          exempt_process_request
          courier
          cost
          type
          cargoMovement {
            id
            secuencia
            bl_guia
            origin
            puerto_carga
            destino
            puerto_descarga
            agente_transporte
            tipo_transporte
            commotity
            measures
            weigth
            vweigth
            etd
            eta
            tipo_despacho
            almacen_fiscal
            recibo
            semaforo
            dua
            fecha_dua
            transporte_interno
            tramitador
            status
            createdAt
            type
            boxes {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          deliveryRoute {
            id
            secuencia
            delivery_man
            date
            status
            comments
            createdAt
            updatedAt
            type
            boxes {
              nextToken
              __typename
            }
            __typename
          }
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          poBoxBoxesId
          boxAssets {
            items {
              id
              name
              path
              type
              size
              createdAt
              updatedAt
              boxBoxAssetsId
              __typename
            }
            nextToken
            __typename
          }
          boxCost {
            id
            invoiceId
            settlementId
            subtotal
            iva
            discount
            comision
            total
            priceType
            exchangeRate
            createdAt
            type
            box {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            data
            easyposLog
            updatedAt
            boxCostBoxId
            __typename
          }
          data
          updatedAt
          cargoMovementBoxesId
          deliveryRouteBoxesId
          boxBoxCostId
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listDeliveryRoutes = /* GraphQL */ `
  query ListDeliveryRoutes(
    $filter: ModelDeliveryRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeliveryRoutes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        secuencia
        delivery_man
        date
        status
        comments
        createdAt
        updatedAt
        type
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const deliveryRoutesByDate = /* GraphQL */ `
  query DeliveryRoutesByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDeliveryRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    deliveryRoutesByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        secuencia
        delivery_man
        date
        status
        comments
        createdAt
        updatedAt
        type
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBox = /* GraphQL */ `
  query GetBox($id: ID!) {
    getBox(id: $id) {
      id
      secuencia
      warehouseNumber
      client
      provedor
      origin
      puerto_carga
      destino
      puerto_descarga
      manifiest_number
      measures
      weigth
      vweigth
      warehouse_prealert_id
      tipo_transporte
      delivery_type
      commotity
      createdAt
      isDelivered
      onRoute
      tracking_num
      tax_calculated
      received
      exempt_process_request
      courier
      cost
      type
      cargoMovement {
        id
        secuencia
        bl_guia
        origin
        puerto_carga
        destino
        puerto_descarga
        agente_transporte
        tipo_transporte
        commotity
        measures
        weigth
        vweigth
        etd
        eta
        tipo_despacho
        almacen_fiscal
        recibo
        semaforo
        dua
        fecha_dua
        transporte_interno
        tramitador
        status
        createdAt
        type
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      deliveryRoute {
        id
        secuencia
        delivery_man
        date
        status
        comments
        createdAt
        updatedAt
        type
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      poBox {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      poBoxBoxesId
      boxAssets {
        items {
          id
          name
          path
          type
          size
          createdAt
          updatedAt
          boxBoxAssetsId
          __typename
        }
        nextToken
        __typename
      }
      boxCost {
        id
        invoiceId
        settlementId
        subtotal
        iva
        discount
        comision
        total
        priceType
        exchangeRate
        createdAt
        type
        box {
          id
          secuencia
          warehouseNumber
          client
          provedor
          origin
          puerto_carga
          destino
          puerto_descarga
          manifiest_number
          measures
          weigth
          vweigth
          warehouse_prealert_id
          tipo_transporte
          delivery_type
          commotity
          createdAt
          isDelivered
          onRoute
          tracking_num
          tax_calculated
          received
          exempt_process_request
          courier
          cost
          type
          cargoMovement {
            id
            secuencia
            bl_guia
            origin
            puerto_carga
            destino
            puerto_descarga
            agente_transporte
            tipo_transporte
            commotity
            measures
            weigth
            vweigth
            etd
            eta
            tipo_despacho
            almacen_fiscal
            recibo
            semaforo
            dua
            fecha_dua
            transporte_interno
            tramitador
            status
            createdAt
            type
            boxes {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          deliveryRoute {
            id
            secuencia
            delivery_man
            date
            status
            comments
            createdAt
            updatedAt
            type
            boxes {
              nextToken
              __typename
            }
            __typename
          }
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          poBoxBoxesId
          boxAssets {
            items {
              id
              name
              path
              type
              size
              createdAt
              updatedAt
              boxBoxAssetsId
              __typename
            }
            nextToken
            __typename
          }
          boxCost {
            id
            invoiceId
            settlementId
            subtotal
            iva
            discount
            comision
            total
            priceType
            exchangeRate
            createdAt
            type
            box {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            data
            easyposLog
            updatedAt
            boxCostBoxId
            __typename
          }
          data
          updatedAt
          cargoMovementBoxesId
          deliveryRouteBoxesId
          boxBoxCostId
          __typename
        }
        data
        easyposLog
        updatedAt
        boxCostBoxId
        __typename
      }
      data
      updatedAt
      cargoMovementBoxesId
      deliveryRouteBoxesId
      boxBoxCostId
      __typename
    }
  }
`;
export const listBoxes = /* GraphQL */ `
  query ListBoxes(
    $filter: ModelBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBoxes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        secuencia
        warehouseNumber
        client
        provedor
        origin
        puerto_carga
        destino
        puerto_descarga
        manifiest_number
        measures
        weigth
        vweigth
        warehouse_prealert_id
        tipo_transporte
        delivery_type
        commotity
        createdAt
        isDelivered
        onRoute
        tracking_num
        tax_calculated
        received
        exempt_process_request
        courier
        cost
        type
        cargoMovement {
          id
          secuencia
          bl_guia
          origin
          puerto_carga
          destino
          puerto_descarga
          agente_transporte
          tipo_transporte
          commotity
          measures
          weigth
          vweigth
          etd
          eta
          tipo_despacho
          almacen_fiscal
          recibo
          semaforo
          dua
          fecha_dua
          transporte_interno
          tramitador
          status
          createdAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        deliveryRoute {
          id
          secuencia
          delivery_man
          date
          status
          comments
          createdAt
          updatedAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          __typename
        }
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        poBoxBoxesId
        boxAssets {
          items {
            id
            name
            path
            type
            size
            createdAt
            updatedAt
            boxBoxAssetsId
            __typename
          }
          nextToken
          __typename
        }
        boxCost {
          id
          invoiceId
          settlementId
          subtotal
          iva
          discount
          comision
          total
          priceType
          exchangeRate
          createdAt
          type
          box {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          data
          easyposLog
          updatedAt
          boxCostBoxId
          __typename
        }
        data
        updatedAt
        cargoMovementBoxesId
        deliveryRouteBoxesId
        boxBoxCostId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boxesByWarehouse = /* GraphQL */ `
  query BoxesByWarehouse(
    $warehouseNumber: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boxesByWarehouse(
      warehouseNumber: $warehouseNumber
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        secuencia
        warehouseNumber
        client
        provedor
        origin
        puerto_carga
        destino
        puerto_descarga
        manifiest_number
        measures
        weigth
        vweigth
        warehouse_prealert_id
        tipo_transporte
        delivery_type
        commotity
        createdAt
        isDelivered
        onRoute
        tracking_num
        tax_calculated
        received
        exempt_process_request
        courier
        cost
        type
        cargoMovement {
          id
          secuencia
          bl_guia
          origin
          puerto_carga
          destino
          puerto_descarga
          agente_transporte
          tipo_transporte
          commotity
          measures
          weigth
          vweigth
          etd
          eta
          tipo_despacho
          almacen_fiscal
          recibo
          semaforo
          dua
          fecha_dua
          transporte_interno
          tramitador
          status
          createdAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        deliveryRoute {
          id
          secuencia
          delivery_man
          date
          status
          comments
          createdAt
          updatedAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          __typename
        }
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        poBoxBoxesId
        boxAssets {
          items {
            id
            name
            path
            type
            size
            createdAt
            updatedAt
            boxBoxAssetsId
            __typename
          }
          nextToken
          __typename
        }
        boxCost {
          id
          invoiceId
          settlementId
          subtotal
          iva
          discount
          comision
          total
          priceType
          exchangeRate
          createdAt
          type
          box {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          data
          easyposLog
          updatedAt
          boxCostBoxId
          __typename
        }
        data
        updatedAt
        cargoMovementBoxesId
        deliveryRouteBoxesId
        boxBoxCostId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boxesByDate = /* GraphQL */ `
  query BoxesByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boxesByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        secuencia
        warehouseNumber
        client
        provedor
        origin
        puerto_carga
        destino
        puerto_descarga
        manifiest_number
        measures
        weigth
        vweigth
        warehouse_prealert_id
        tipo_transporte
        delivery_type
        commotity
        createdAt
        isDelivered
        onRoute
        tracking_num
        tax_calculated
        received
        exempt_process_request
        courier
        cost
        type
        cargoMovement {
          id
          secuencia
          bl_guia
          origin
          puerto_carga
          destino
          puerto_descarga
          agente_transporte
          tipo_transporte
          commotity
          measures
          weigth
          vweigth
          etd
          eta
          tipo_despacho
          almacen_fiscal
          recibo
          semaforo
          dua
          fecha_dua
          transporte_interno
          tramitador
          status
          createdAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        deliveryRoute {
          id
          secuencia
          delivery_man
          date
          status
          comments
          createdAt
          updatedAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          __typename
        }
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        poBoxBoxesId
        boxAssets {
          items {
            id
            name
            path
            type
            size
            createdAt
            updatedAt
            boxBoxAssetsId
            __typename
          }
          nextToken
          __typename
        }
        boxCost {
          id
          invoiceId
          settlementId
          subtotal
          iva
          discount
          comision
          total
          priceType
          exchangeRate
          createdAt
          type
          box {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          data
          easyposLog
          updatedAt
          boxCostBoxId
          __typename
        }
        data
        updatedAt
        cargoMovementBoxesId
        deliveryRouteBoxesId
        boxBoxCostId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boxesByPoBox = /* GraphQL */ `
  query BoxesByPoBox(
    $poBoxBoxesId: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boxesByPoBox(
      poBoxBoxesId: $poBoxBoxesId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        secuencia
        warehouseNumber
        client
        provedor
        origin
        puerto_carga
        destino
        puerto_descarga
        manifiest_number
        measures
        weigth
        vweigth
        warehouse_prealert_id
        tipo_transporte
        delivery_type
        commotity
        createdAt
        isDelivered
        onRoute
        tracking_num
        tax_calculated
        received
        exempt_process_request
        courier
        cost
        type
        cargoMovement {
          id
          secuencia
          bl_guia
          origin
          puerto_carga
          destino
          puerto_descarga
          agente_transporte
          tipo_transporte
          commotity
          measures
          weigth
          vweigth
          etd
          eta
          tipo_despacho
          almacen_fiscal
          recibo
          semaforo
          dua
          fecha_dua
          transporte_interno
          tramitador
          status
          createdAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        deliveryRoute {
          id
          secuencia
          delivery_man
          date
          status
          comments
          createdAt
          updatedAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          __typename
        }
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        poBoxBoxesId
        boxAssets {
          items {
            id
            name
            path
            type
            size
            createdAt
            updatedAt
            boxBoxAssetsId
            __typename
          }
          nextToken
          __typename
        }
        boxCost {
          id
          invoiceId
          settlementId
          subtotal
          iva
          discount
          comision
          total
          priceType
          exchangeRate
          createdAt
          type
          box {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          data
          easyposLog
          updatedAt
          boxCostBoxId
          __typename
        }
        data
        updatedAt
        cargoMovementBoxesId
        deliveryRouteBoxesId
        boxBoxCostId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAddress = /* GraphQL */ `
  query GetAddress($id: ID!) {
    getAddress(id: $id) {
      id
      name
      delivery_province
      delivery_canton
      delivery_district
      address
      createdAt
      poBox {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      type
      updatedAt
      poBoxAddressesId
      __typename
    }
  }
`;
export const listAddresses = /* GraphQL */ `
  query ListAddresses(
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        delivery_province
        delivery_canton
        delivery_district
        address
        createdAt
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        type
        updatedAt
        poBoxAddressesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const addressByDate = /* GraphQL */ `
  query AddressByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addressByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        delivery_province
        delivery_canton
        delivery_district
        address
        createdAt
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        type
        updatedAt
        poBoxAddressesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBoxCost = /* GraphQL */ `
  query GetBoxCost($id: ID!) {
    getBoxCost(id: $id) {
      id
      invoiceId
      settlementId
      subtotal
      iva
      discount
      comision
      total
      priceType
      exchangeRate
      createdAt
      type
      box {
        id
        secuencia
        warehouseNumber
        client
        provedor
        origin
        puerto_carga
        destino
        puerto_descarga
        manifiest_number
        measures
        weigth
        vweigth
        warehouse_prealert_id
        tipo_transporte
        delivery_type
        commotity
        createdAt
        isDelivered
        onRoute
        tracking_num
        tax_calculated
        received
        exempt_process_request
        courier
        cost
        type
        cargoMovement {
          id
          secuencia
          bl_guia
          origin
          puerto_carga
          destino
          puerto_descarga
          agente_transporte
          tipo_transporte
          commotity
          measures
          weigth
          vweigth
          etd
          eta
          tipo_despacho
          almacen_fiscal
          recibo
          semaforo
          dua
          fecha_dua
          transporte_interno
          tramitador
          status
          createdAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        deliveryRoute {
          id
          secuencia
          delivery_man
          date
          status
          comments
          createdAt
          updatedAt
          type
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          __typename
        }
        poBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        poBoxBoxesId
        boxAssets {
          items {
            id
            name
            path
            type
            size
            createdAt
            updatedAt
            boxBoxAssetsId
            __typename
          }
          nextToken
          __typename
        }
        boxCost {
          id
          invoiceId
          settlementId
          subtotal
          iva
          discount
          comision
          total
          priceType
          exchangeRate
          createdAt
          type
          box {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          data
          easyposLog
          updatedAt
          boxCostBoxId
          __typename
        }
        data
        updatedAt
        cargoMovementBoxesId
        deliveryRouteBoxesId
        boxBoxCostId
        __typename
      }
      data
      easyposLog
      updatedAt
      boxCostBoxId
      __typename
    }
  }
`;
export const listBoxCosts = /* GraphQL */ `
  query ListBoxCosts(
    $filter: ModelBoxCostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBoxCosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        invoiceId
        settlementId
        subtotal
        iva
        discount
        comision
        total
        priceType
        exchangeRate
        createdAt
        type
        box {
          id
          secuencia
          warehouseNumber
          client
          provedor
          origin
          puerto_carga
          destino
          puerto_descarga
          manifiest_number
          measures
          weigth
          vweigth
          warehouse_prealert_id
          tipo_transporte
          delivery_type
          commotity
          createdAt
          isDelivered
          onRoute
          tracking_num
          tax_calculated
          received
          exempt_process_request
          courier
          cost
          type
          cargoMovement {
            id
            secuencia
            bl_guia
            origin
            puerto_carga
            destino
            puerto_descarga
            agente_transporte
            tipo_transporte
            commotity
            measures
            weigth
            vweigth
            etd
            eta
            tipo_despacho
            almacen_fiscal
            recibo
            semaforo
            dua
            fecha_dua
            transporte_interno
            tramitador
            status
            createdAt
            type
            boxes {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          deliveryRoute {
            id
            secuencia
            delivery_man
            date
            status
            comments
            createdAt
            updatedAt
            type
            boxes {
              nextToken
              __typename
            }
            __typename
          }
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          poBoxBoxesId
          boxAssets {
            items {
              id
              name
              path
              type
              size
              createdAt
              updatedAt
              boxBoxAssetsId
              __typename
            }
            nextToken
            __typename
          }
          boxCost {
            id
            invoiceId
            settlementId
            subtotal
            iva
            discount
            comision
            total
            priceType
            exchangeRate
            createdAt
            type
            box {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            data
            easyposLog
            updatedAt
            boxCostBoxId
            __typename
          }
          data
          updatedAt
          cargoMovementBoxesId
          deliveryRouteBoxesId
          boxBoxCostId
          __typename
        }
        data
        easyposLog
        updatedAt
        boxCostBoxId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boxCostsByDate = /* GraphQL */ `
  query BoxCostsByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBoxCostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boxCostsByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        invoiceId
        settlementId
        subtotal
        iva
        discount
        comision
        total
        priceType
        exchangeRate
        createdAt
        type
        box {
          id
          secuencia
          warehouseNumber
          client
          provedor
          origin
          puerto_carga
          destino
          puerto_descarga
          manifiest_number
          measures
          weigth
          vweigth
          warehouse_prealert_id
          tipo_transporte
          delivery_type
          commotity
          createdAt
          isDelivered
          onRoute
          tracking_num
          tax_calculated
          received
          exempt_process_request
          courier
          cost
          type
          cargoMovement {
            id
            secuencia
            bl_guia
            origin
            puerto_carga
            destino
            puerto_descarga
            agente_transporte
            tipo_transporte
            commotity
            measures
            weigth
            vweigth
            etd
            eta
            tipo_despacho
            almacen_fiscal
            recibo
            semaforo
            dua
            fecha_dua
            transporte_interno
            tramitador
            status
            createdAt
            type
            boxes {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          deliveryRoute {
            id
            secuencia
            delivery_man
            date
            status
            comments
            createdAt
            updatedAt
            type
            boxes {
              nextToken
              __typename
            }
            __typename
          }
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          poBoxBoxesId
          boxAssets {
            items {
              id
              name
              path
              type
              size
              createdAt
              updatedAt
              boxBoxAssetsId
              __typename
            }
            nextToken
            __typename
          }
          boxCost {
            id
            invoiceId
            settlementId
            subtotal
            iva
            discount
            comision
            total
            priceType
            exchangeRate
            createdAt
            type
            box {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            data
            easyposLog
            updatedAt
            boxCostBoxId
            __typename
          }
          data
          updatedAt
          cargoMovementBoxesId
          deliveryRouteBoxesId
          boxBoxCostId
          __typename
        }
        data
        easyposLog
        updatedAt
        boxCostBoxId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAsset = /* GraphQL */ `
  query GetAsset($id: ID!) {
    getAsset(id: $id) {
      id
      name
      path
      type
      size
      createdAt
      updatedAt
      boxBoxAssetsId
      __typename
    }
  }
`;
export const listAssets = /* GraphQL */ `
  query ListAssets(
    $filter: ModelAssetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        path
        type
        size
        createdAt
        updatedAt
        boxBoxAssetsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPoBox = /* GraphQL */ `
  query GetPoBox($id: ID!) {
    getPoBox(id: $id) {
      id
      boxNumber
      name
      email
      phone
      warehouse_client_id
      type
      createdAt
      userId
      boxes {
        items {
          id
          secuencia
          warehouseNumber
          client
          provedor
          origin
          puerto_carga
          destino
          puerto_descarga
          manifiest_number
          measures
          weigth
          vweigth
          warehouse_prealert_id
          tipo_transporte
          delivery_type
          commotity
          createdAt
          isDelivered
          onRoute
          tracking_num
          tax_calculated
          received
          exempt_process_request
          courier
          cost
          type
          cargoMovement {
            id
            secuencia
            bl_guia
            origin
            puerto_carga
            destino
            puerto_descarga
            agente_transporte
            tipo_transporte
            commotity
            measures
            weigth
            vweigth
            etd
            eta
            tipo_despacho
            almacen_fiscal
            recibo
            semaforo
            dua
            fecha_dua
            transporte_interno
            tramitador
            status
            createdAt
            type
            boxes {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          deliveryRoute {
            id
            secuencia
            delivery_man
            date
            status
            comments
            createdAt
            updatedAt
            type
            boxes {
              nextToken
              __typename
            }
            __typename
          }
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          poBoxBoxesId
          boxAssets {
            items {
              id
              name
              path
              type
              size
              createdAt
              updatedAt
              boxBoxAssetsId
              __typename
            }
            nextToken
            __typename
          }
          boxCost {
            id
            invoiceId
            settlementId
            subtotal
            iva
            discount
            comision
            total
            priceType
            exchangeRate
            createdAt
            type
            box {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            data
            easyposLog
            updatedAt
            boxCostBoxId
            __typename
          }
          data
          updatedAt
          cargoMovementBoxesId
          deliveryRouteBoxesId
          boxBoxCostId
          __typename
        }
        nextToken
        __typename
      }
      addresses {
        items {
          id
          name
          delivery_province
          delivery_canton
          delivery_district
          address
          createdAt
          poBox {
            id
            boxNumber
            name
            email
            phone
            warehouse_client_id
            type
            createdAt
            userId
            boxes {
              nextToken
              __typename
            }
            addresses {
              nextToken
              __typename
            }
            updatedAt
            __typename
          }
          type
          updatedAt
          poBoxAddressesId
          __typename
        }
        nextToken
        __typename
      }
      updatedAt
      __typename
    }
  }
`;
export const listPoBoxes = /* GraphQL */ `
  query ListPoBoxes(
    $filter: ModelPoBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPoBoxes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const poBoxesByDate = /* GraphQL */ `
  query PoBoxesByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPoBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    poBoxesByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const poBoxByUser = /* GraphQL */ `
  query PoBoxByUser(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelPoBoxFilterInput
    $limit: Int
    $nextToken: String
  ) {
    poBoxByUser(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPoBoxReferal = /* GraphQL */ `
  query GetPoBoxReferal($id: ID!) {
    getPoBoxReferal(id: $id) {
      id
      referFromPoBox {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      referToPoBox {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      referalCompleted
      type
      createdAt
      updatedAt
      poBoxReferalReferFromPoBoxId
      poBoxReferalReferToPoBoxId
      __typename
    }
  }
`;
export const listPoBoxReferals = /* GraphQL */ `
  query ListPoBoxReferals(
    $filter: ModelPoBoxReferalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPoBoxReferals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        referFromPoBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        referToPoBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        referalCompleted
        type
        createdAt
        updatedAt
        poBoxReferalReferFromPoBoxId
        poBoxReferalReferToPoBoxId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const poBoxReferalsByDate = /* GraphQL */ `
  query PoBoxReferalsByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPoBoxReferalFilterInput
    $limit: Int
    $nextToken: String
  ) {
    poBoxReferalsByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        referFromPoBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        referToPoBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        referalCompleted
        type
        createdAt
        updatedAt
        poBoxReferalReferFromPoBoxId
        poBoxReferalReferToPoBoxId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPoBoxReferalPoint = /* GraphQL */ `
  query GetPoBoxReferalPoint($id: ID!) {
    getPoBoxReferalPoint(id: $id) {
      id
      referalPoBox {
        id
        boxNumber
        name
        email
        phone
        warehouse_client_id
        type
        createdAt
        userId
        boxes {
          items {
            id
            secuencia
            warehouseNumber
            client
            provedor
            origin
            puerto_carga
            destino
            puerto_descarga
            manifiest_number
            measures
            weigth
            vweigth
            warehouse_prealert_id
            tipo_transporte
            delivery_type
            commotity
            createdAt
            isDelivered
            onRoute
            tracking_num
            tax_calculated
            received
            exempt_process_request
            courier
            cost
            type
            cargoMovement {
              id
              secuencia
              bl_guia
              origin
              puerto_carga
              destino
              puerto_descarga
              agente_transporte
              tipo_transporte
              commotity
              measures
              weigth
              vweigth
              etd
              eta
              tipo_despacho
              almacen_fiscal
              recibo
              semaforo
              dua
              fecha_dua
              transporte_interno
              tramitador
              status
              createdAt
              type
              updatedAt
              __typename
            }
            deliveryRoute {
              id
              secuencia
              delivery_man
              date
              status
              comments
              createdAt
              updatedAt
              type
              __typename
            }
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            poBoxBoxesId
            boxAssets {
              nextToken
              __typename
            }
            boxCost {
              id
              invoiceId
              settlementId
              subtotal
              iva
              discount
              comision
              total
              priceType
              exchangeRate
              createdAt
              type
              data
              easyposLog
              updatedAt
              boxCostBoxId
              __typename
            }
            data
            updatedAt
            cargoMovementBoxesId
            deliveryRouteBoxesId
            boxBoxCostId
            __typename
          }
          nextToken
          __typename
        }
        addresses {
          items {
            id
            name
            delivery_province
            delivery_canton
            delivery_district
            address
            createdAt
            poBox {
              id
              boxNumber
              name
              email
              phone
              warehouse_client_id
              type
              createdAt
              userId
              updatedAt
              __typename
            }
            type
            updatedAt
            poBoxAddressesId
            __typename
          }
          nextToken
          __typename
        }
        updatedAt
        __typename
      }
      amount
      description
      type
      createdAt
      updatedAt
      poBoxReferalPointReferalPoBoxId
      __typename
    }
  }
`;
export const listPoBoxReferalPoints = /* GraphQL */ `
  query ListPoBoxReferalPoints(
    $filter: ModelPoBoxReferalPointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPoBoxReferalPoints(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        referalPoBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        amount
        description
        type
        createdAt
        updatedAt
        poBoxReferalPointReferalPoBoxId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const poBoxReferalPointsByDate = /* GraphQL */ `
  query PoBoxReferalPointsByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPoBoxReferalPointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    poBoxReferalPointsByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        referalPoBox {
          id
          boxNumber
          name
          email
          phone
          warehouse_client_id
          type
          createdAt
          userId
          boxes {
            items {
              id
              secuencia
              warehouseNumber
              client
              provedor
              origin
              puerto_carga
              destino
              puerto_descarga
              manifiest_number
              measures
              weigth
              vweigth
              warehouse_prealert_id
              tipo_transporte
              delivery_type
              commotity
              createdAt
              isDelivered
              onRoute
              tracking_num
              tax_calculated
              received
              exempt_process_request
              courier
              cost
              type
              poBoxBoxesId
              data
              updatedAt
              cargoMovementBoxesId
              deliveryRouteBoxesId
              boxBoxCostId
              __typename
            }
            nextToken
            __typename
          }
          addresses {
            items {
              id
              name
              delivery_province
              delivery_canton
              delivery_district
              address
              createdAt
              type
              updatedAt
              poBoxAddressesId
              __typename
            }
            nextToken
            __typename
          }
          updatedAt
          __typename
        }
        amount
        description
        type
        createdAt
        updatedAt
        poBoxReferalPointReferalPoBoxId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPrice = /* GraphQL */ `
  query GetPrice($id: ID!) {
    getPrice(id: $id) {
      id
      type
      secuencia
      name
      isAllInclusive
      isPublic
      isDefault
      isActive
      priceTable
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPrices = /* GraphQL */ `
  query ListPrices(
    $filter: ModelPriceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        secuencia
        name
        isAllInclusive
        isPublic
        isDefault
        isActive
        priceTable
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pricesByDate = /* GraphQL */ `
  query PricesByDate(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPriceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pricesByDate(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        secuencia
        name
        isAllInclusive
        isPublic
        isDefault
        isActive
        priceTable
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTypeCounter = /* GraphQL */ `
  query GetTypeCounter($id: ID!) {
    getTypeCounter(id: $id) {
      id
      type
      count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTypeCounters = /* GraphQL */ `
  query ListTypeCounters(
    $filter: ModelTypeCounterFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTypeCounters(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        count
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
